import { render, staticRenderFns } from "./MyWork.vue?vue&type=template&id=2a68f337&scoped=true&"
import script from "./MyWork.vue?vue&type=script&lang=js&"
export * from "./MyWork.vue?vue&type=script&lang=js&"
import style0 from "./MyWork.vue?vue&type=style&index=0&id=2a68f337&prod&lang=scss&scoped=true&"
import style1 from "./MyWork.vue?vue&type=style&index=1&id=2a68f337&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a68f337",
  null
  
)

export default component.exports